import API from './api'
import AUTHENTICATION from './authentication'
import COMMON from './common'
import TRAINING from './training'
import SUBJECT from './subject'
import TEAM from './team'
import QUESTION from './card'
import REMINDING_SETTING from './reminding-setting'
import USER from './user'
import CHANGE_PASSWORD from './user-password'
import SIGNUP from './sign-up'
import MEDIA_IMAGE from './media-image'
import MEDIA_FOLDER from './media-folder'
import MEDIA_DIRECTORY from './media-directory'
import MEDIA_VIDEO from './media-video'
import SHOP from './shop'
import INTEGRATION from './integration'
import EXCEL_EXPORT from './excel-export'
import LEARNING_CONTENT from './learning-content'
import USER_MESSAGE from './user-message'
import DOCUMENT from './document'
import REPORT_PARTICIPATION from './report-participation'
import REPORT_ACTIVATION from './report-activation'
import SHOP_MESSAGE from './shop-message'
import COURSE from './course'
import CUSTOM_DOMAIN from './custom-domain'
import COURSE_STATISTICS from './course-statistics'
import COURSE_TIME_SERIES from './course-time-series'
import APPSUMO from './appsumo'
import LIMIT from './limit'
import PAYMENT_INTEGRATION from './payment-integration'
import COURSE_COLLECTION from './course-collection'
import TEAMS from './teams'
import LLM from './llm'
import BADGE from './badge'
import CERTIFICATE from './certificate'
import AI_CREATOR from './ai-creator'
import COURSE_CREATION from './course-creation'
import IFRAMELY from './iframely'
import INSTRUCTION from './instruction'
import COLLECTION from './collection'
import LOCALIZATIONS from './localizations'
import MARKETING from './marketing'
import EMAIL_DOMAIN_RULE from './email-domain-rule'
import HEADLESS from './headless'
import WORKSPACE_MEMBER from './workspace-member'
import SHOP_WEBHOOK from './shop-webhook'
import API_KEY from './api-key'
import MCP_CONNECTION from './mcp-connection'
import SCORM from './scorm'
import TAG from './tag'
import CATALOG from './catalog'
import LEARNING from './learning'

const URL = {
  ...API,
  ...AUTHENTICATION,
  ...COMMON,
  ...TRAINING,
  ...SUBJECT,
  ...TEAM,
  ...QUESTION,
  ...REMINDING_SETTING,
  ...USER,
  ...CHANGE_PASSWORD,
  ...SIGNUP,
  ...MEDIA_IMAGE,
  ...MEDIA_FOLDER,
  ...MEDIA_DIRECTORY,
  ...MEDIA_VIDEO,
  ...SHOP,
  ...INTEGRATION,
  ...EXCEL_EXPORT,
  ...LEARNING_CONTENT,
  ...USER_MESSAGE,
  ...DOCUMENT,
  ...REPORT_PARTICIPATION,
  ...REPORT_ACTIVATION,
  ...SHOP_MESSAGE,
  ...COURSE,
  ...CUSTOM_DOMAIN,
  ...COURSE_TIME_SERIES,
  ...COURSE_STATISTICS,
  ...APPSUMO,
  ...LIMIT,
  ...PAYMENT_INTEGRATION,
  ...COURSE_COLLECTION,
  ...TEAMS,
  ...LLM,
  ...BADGE,
  ...CERTIFICATE,
  ...AI_CREATOR,
  ...COURSE_CREATION,
  ...IFRAMELY,
  ...INSTRUCTION,
  ...COLLECTION,
  ...LOCALIZATIONS,
  ...MARKETING,
  ...EMAIL_DOMAIN_RULE,
  ...HEADLESS,
  ...WORKSPACE_MEMBER,
  ...SHOP_WEBHOOK,
  ...API_KEY,
  ...MCP_CONNECTION,
  ...SCORM,
  ...TAG,
  ...CATALOG,
  ...LEARNING,
}

export default URL
